import React, { useState } from 'react';
import BlogCard from './BlogCard';
import blogPosts from '../data/blogData';
import SeoHelmet from "../components/SeoHelmet";

const Blog = () => {
  const postsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(blogPosts.length / postsPerPage);
  const startIdx = (currentPage - 1) * postsPerPage;
  const selectedPosts = blogPosts.slice(startIdx, startIdx + postsPerPage);

  // Utility: Group posts into chunks of 3
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const chunkedPosts = chunkArray(selectedPosts, 3); // each row has 1 big + 2 small

  return (
      <>
      <SeoHelmet />
    <section className="blog">
      <div className="container">
        {chunkedPosts.map((chunk, rowIndex) => {
          const [bigPost, smallPost1, smallPost2] = chunk;
          const isEven = rowIndex % 2 === 0;

          return (
            
            <div className="row" key={bigPost.id}>
              {isEven ? (
                // Even row: Big left, small right
                <>
                  <div className="col-sm-5">
                    <BlogCard post={bigPost} height="690px" />
                  </div>
                  <div className="col-sm-7">
                    {smallPost1 && (
                      <BlogCard post={smallPost1} height="330px" style={{ marginBottom: '30px' }} />
                    )}
                    {smallPost2 && (
                      <BlogCard post={smallPost2} height="330px" />
                    )}
                  </div>
                </>
              ) : (
                // Odd row: Small left, big right
                <>
                  <div className="col-sm-7">
                    {smallPost1 && (
                      <BlogCard post={smallPost1} height="330px" style={{ marginBottom: '30px' }} />
                    )}
                    {smallPost2 && (
                      <BlogCard post={smallPost2} height="330px" />
                    )}
                  </div>
                  <div className="col-sm-5">
                    <BlogCard post={bigPost} height="690px" />
                  </div>
                </>
              )}
            </div>
          );
        })}

        {/* Pagination Controls */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              style={{
                  margin: '0 5px',
                  padding: '8px 12px',
                  background: 'transparent',
                  color: '#fff',
                  border: 'none',
                  borderBottom: currentPage === i + 1 ? '2px solid #fff' : '2px solid transparent',
                  fontWeight: currentPage === i + 1 ? 'bold' : 'normal',
                  cursor: 'pointer',
                }}
            >
              {i + 1}
            </button>
          ))} 
        </div>
      </div>
    </section>
    </>
  );
};

export default Blog;
